import type { App, DirectiveBinding } from 'vue'
import BButton from '@/components/ui/bootstrap-compat/BButton.vue'
import BCollapse from '@/components/ui/bootstrap-compat/BCollapse.vue'
import BDropdown from '@/components/ui/bootstrap-compat/BDropdown.vue'
import BDropdownDivider from '@/components/ui/bootstrap-compat/BDropdownDivider.vue'
import BDropdownItem from '@/components/ui/bootstrap-compat/BDropdownItem.vue'
import BFormCheckbox from '@/components/ui/bootstrap-compat/BFormCheckbox.vue'
import BFormCheckboxGroup from '@/components/ui/bootstrap-compat/BFormCheckboxGroup.vue'
import BFormGroup from '@/components/ui/bootstrap-compat/BFormGroup.vue'
import BFormInput from '@/components/ui/bootstrap-compat/BFormInput.vue'
import BFormRadioGroup from '@/components/ui/bootstrap-compat/BFormRadioGroup.vue'
import BFormSelect from '@/components/ui/bootstrap-compat/BFormSelect.vue'
import BFormSelectOption from '@/components/ui/bootstrap-compat/BFormSelectOption.vue'
import BFormTextarea from '@/components/ui/bootstrap-compat/BFormTextarea.vue'
import BModal from '@/components/ui/bootstrap-compat/BModal.vue'
import BPagination from '@/components/ui/bootstrap-compat/BPagination.vue'
import BSpinner from '@/components/ui/bootstrap-compat/BSpinner.vue'
import BTab from '@/components/ui/bootstrap-compat/BTab.vue'
import BTabs from '@/components/ui/bootstrap-compat/BTabs.vue'
import { modalService } from '@/components/ui/bootstrap-compat/modal-manager'

const components = {
  BButton,
  BCollapse,
  BDropdown,
  BDropdownDivider,
  BDropdownItem,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormSelect,
  BFormSelectOption,
  BFormTextarea,
  BModal,
  BPagination,
  BSpinner,
  BTab,
  BTabs
}

const listenerKey = Symbol('b-modal-listener')
type ModalElement = HTMLElement & { [listenerKey]?: EventListener }

const modalId = (binding: DirectiveBinding) =>
  String(binding.value || binding.arg || '')

const bindModalDirective = (element: ModalElement, binding: DirectiveBinding) => {
  if (element[listenerKey]) element.removeEventListener('click', element[listenerKey])
  const listener = () => modalService.show(modalId(binding))
  element[listenerKey] = listener
  element.addEventListener('click', listener)
}

export default {
  install(app: App) {
    Object.entries(components).forEach(([name, component]) => app.component(name, component))
    app.config.globalProperties.$bvModal = modalService
    app.directive('b-modal', {
      mounted: bindModalDirective,
      updated: bindModalDirective,
      unmounted(element: ModalElement) {
        if (element[listenerKey]) element.removeEventListener('click', element[listenerKey])
      }
    })
  }
}
